import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

interface AiGenerateChecklistBannerProps {
  photoRoomCount: number;
  onGenerate: () => void;
  className?: string;
}

/** Prompt to run listing photo scan into Unit Check + Tasks while editing a checklist. */
export function AiGenerateChecklistBanner({
  photoRoomCount,
  onGenerate,
  className,
}: AiGenerateChecklistBannerProps) {
  const hasPhotos = photoRoomCount > 0;

  return (
    <div
      className={
        className ??
        "flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-primary/20 bg-primary/5 px-4 py-3"
      }
    >
      <div className="flex-1 min-w-0 space-y-0.5">
        <p className="text-sm font-medium">Save time with AI</p>
        <p className="text-xs text-muted-foreground leading-snug">
          {hasPhotos
            ? `Scan ${photoRoomCount} room photo${photoRoomCount !== 1 ? "s" : ""} to draft Unit Check items and cleaning tasks. Review everything in one place before adding.`
            : "Upload photos on the Photos tab and assign each to a room, then generate tasks here."}
        </p>
      </div>
      <Button
        type="button"
        size="sm"
        variant={hasPhotos ? "default" : "outline"}
        className="shrink-0"
        onClick={onGenerate}
        disabled={!hasPhotos}
      >
        <Sparkles className="h-4 w-4 mr-2" />
        Generate with AI
      </Button>
    </div>
  );
}
